module.exports = __webpack_public_path__ + "src/assets/img/german-selector-trajectory-mobile.39c58a66.png";